import * as path from "path";

import { httpGet } from "../../../Commons/HttpServer/AttributeRouting/Methods";
import { httpReturn } from "../../../Commons/HttpServer/AttributeRouting/Results";
import {
    FileStreamResult,
    ProxyGetRequestToResult,
    StreamReturnResult,
} from "../../../Commons/HttpServer/AttributeRouting/Results/StreamResultHandler";
import { SingletonController } from "../../../Commons/HttpServer/ExpressWrapper/SingletonController";

import { BuildServerClientJsControllerOptions } from "./BuildServerClientJsController";

export interface BuildServerClientJsFromResourcesOptions {
    frontEndDevMode: boolean;
    devServerUrl: string;
}

const defaultOptions: BuildServerClientJsFromResourcesOptions = {
    frontEndDevMode: false,
    devServerUrl: "https://localhost:8081",
};

export class BuildServerClientJsFromResourcesController extends SingletonController {
    private readonly options: Partial<BuildServerClientJsControllerOptions>;
    private readonly disableClientOverride: boolean;

    public constructor(disableClientOverride: boolean, options: Partial<BuildServerClientJsControllerOptions>) {
        super();
        this.disableClientOverride = disableClientOverride;
        this.options = { ...defaultOptions, ...options };
    }

    @httpGet("/public/scripts/client.js", httpReturn.StreamWithMime("application/javascript"))
    public async getClientJsScript(): Promise<StreamReturnResult> {
        if (this.disableClientOverride) {
            return new FileStreamResult(
                path.join(__dirname, "..", "..", "..", "StaticFilesForProductionResourcesDir", "client.js")
            );
        }
        try {
            if (this.options.frontEndDevMode) {
                return new ProxyGetRequestToResult(`${this.options.devServerUrl}/forms-helper/enhancedClient.js`);
            } else {
                return new FileStreamResult(
                    path.join(__dirname, "..", "..", "..", "LocalServerFrontEndDist", "enhancedClient.js")
                );
            }
        } catch {
            return new FileStreamResult(
                path.join(__dirname, "..", "..", "..", "StaticFilesForProductionResourcesDir", "client.js")
            );
        }
    }

    @httpGet("/public/scripts/client.min.js", httpReturn.StreamWithMime("application/javascript"))
    public async getClientMinJsScript(): Promise<StreamReturnResult> {
        if (this.disableClientOverride) {
            return new FileStreamResult(
                path.join(__dirname, "..", "..", "..", "StaticFilesForProductionResourcesDir", "client.min.js")
            );
        }
        try {
            if (this.options.frontEndDevMode) {
                return new ProxyGetRequestToResult(`${this.options.devServerUrl}/forms-helper/enhancedClient.js`);
            } else {
                return new FileStreamResult(
                    path.join(__dirname, "..", "..", "..", "LocalServerFrontEndDist", "enhancedClient.js")
                );
            }
        } catch {
            return new FileStreamResult(
                path.join(__dirname, "..", "..", "..", "StaticFilesForProductionResourcesDir", "client.min.js")
            );
        }
    }

    @httpGet("/public/scripts/client-original.js", httpReturn.StreamWithMime("application/javascript"))
    public async getClientJsScriptOriginal(): Promise<StreamReturnResult> {
        return new FileStreamResult(
            path.join(__dirname, "..", "..", "..", "StaticFilesForProductionResourcesDir", "client.js")
        );
    }

    @httpGet("public/scripts/client-original.min.js", httpReturn.StreamWithMime("application/javascript"))
    public async getClientMinJsScriptOriginal(): Promise<StreamReturnResult> {
        return new FileStreamResult(
            path.join(__dirname, "..", "..", "..", "StaticFilesForProductionResourcesDir", "client.min.js")
        );
    }
}
